module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (117).cfb24a85.jpg";